import { ELEMENT_TYPE } from 'app/shop-ui/constants';
import { generate as generateRichText } from 'app/shop-ui/component/RichText/define';
import { generate as generateButton } from 'app/shop-ui/component/Button/define';
import { generate as generateMedia } from 'app/shop-ui/component/Media/define';
import { generate as generateDivider } from 'app/shop-ui/component/Divider/define';
import { generate as generateSearchBar } from 'app/shop-ui/component/SearchBar/define';
import { generate as generateProductPromoInfo } from 'app/shop-ui/component/ProductPromoInfo/define';
import { generate as generateBreadcrumb } from 'app/shop-ui/component/Breadcrumb/define';
import { generate as generateMenu } from 'app/shop-ui/component/Menu/define';
import { generate as generateCarousel } from 'app/shop-ui/component/Carousel/define';
import { generate as generateProductGroup } from 'app/shop-ui/component/ProductGroup/define';
import { generate as generateProductSuggestion } from 'app/shop-ui/component/ProductSuggestion/define';
import { generate as generateProductShippingDetail } from 'app/shop-ui/component/ProductShippingDetail/define';
import { generate as generateProductGiveaway } from 'app/shop-ui/component/ProductGiveaway/define';
import { officialSectionTextGenMap } from 'app/shop-ui/section/Text/define';
import { officialSectionImgWallGenMap } from 'app/shop-ui/section/ImgWall/define';
import { officialSectionExhibitGenMap } from 'app/shop-ui/section/Exhibit/define';
import { officialPageSectionGenMap } from 'app/shop-ui/section/PageSection/define';
import {
    createEmptySection,
    OFFICIAL_SECTION_EMPTY_KEY,
} from 'app/shop-ui/section/Empty/define';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function generateElement(
    name: string,
    content: string,
    options?: { shouldWrap?: boolean }
) {
    switch (true) {
        case name.startsWith('official-paragraph-'):
        case name.startsWith('official-heading-'):
            return generateRichText(ELEMENT_TYPE.RICH_TEXT, name, content, options);

        case name.startsWith('official-button-'):
            return generateButton(ELEMENT_TYPE.BUTTON, name, content, options);

        case name.startsWith('official-media-image'):
            return generateMedia(ELEMENT_TYPE.IMAGE, name, options);

        case name.startsWith('official-media-video'):
            return generateMedia(ELEMENT_TYPE.VIDEO, name, options);

        case name.startsWith('official-divider'):
            return generateDivider(ELEMENT_TYPE.DIVIDER, name, options);

        case name.startsWith('official-breadcrumb'):
            return generateBreadcrumb(ELEMENT_TYPE.BREADCRUMB);

        case name.startsWith('official-menu'):
            return generateMenu(ELEMENT_TYPE.MENU, options);

        case name.startsWith('heading-'):
            return officialSectionTextGenMap[name]?.(content);

        case name.startsWith('img-wall-'):
            return officialSectionImgWallGenMap[name]?.(content);

        case name.startsWith('official-search-bar-'):
            return generateSearchBar(ELEMENT_TYPE.SEARCH_BAR, options);

        case name.startsWith('introduction-'):
            return officialSectionExhibitGenMap[name]?.(content);

        case name.startsWith('official-page-product-promo-info'):
            return generateProductPromoInfo(ELEMENT_TYPE.PRODUCT_PROMO_INFO, options);

        case name.startsWith('page-section-'):
            return officialPageSectionGenMap[name]?.(content);

        case name.startsWith('official-carousel'):
            return generateCarousel(ELEMENT_TYPE.CAROUSEL, options);

        case name.startsWith('official-product-group'):
            return generateProductGroup(ELEMENT_TYPE.PRODUCT_GROUP, options);

        case name.startsWith('official-product-suggestion'):
            return generateProductSuggestion(ELEMENT_TYPE.PRODUCT_SUGGESTION, options);

        case name.startsWith('official-product-shipping-detail'):
            return generateProductShippingDetail(
                ELEMENT_TYPE.PRODUCT_SHIPPING_DETAIL,
                options
            );

        case name.startsWith('official-page-product-giveaway'):
            return generateProductGiveaway(ELEMENT_TYPE.PRODUCT_GIVEAWAY, options);

        case name.startsWith(OFFICIAL_SECTION_EMPTY_KEY):
            return createEmptySection();

        default:
            return null;
    }
}
